import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type IntroState = {
    /** Keyed by entry id (or form id outside an entry). true = past the intro, false = back on it. */
    started: Record<string, boolean>;
    /** true once Next was pressed on the copyright cover, false after going Back onto it. */
    coverPassed: Record<string, boolean>;
};

type IntroActions = {
    setStarted: (key: string, started: boolean) => void;
    setCoverPassed: (key: string, passed: boolean) => void;
};

/** Remembers whether the respondent has moved past the cover and the instructions screen. */
export const useFormIntroStore = create<IntroState & IntroActions>()(
    persist(
        (set) => ({
            started: {},
            coverPassed: {},
            setStarted: (key, started) =>
                set((state) => ({
                    started: { ...state.started, [key]: started },
                })),
            setCoverPassed: (key, passed) =>
                set((state) => ({
                    coverPassed: { ...state.coverPassed, [key]: passed },
                })),
        }),
        {
            name: "form-intro-store",
            storage: createJSONStorage(() => sessionStorage),
        }
    )
);
